// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__11gwD","label":"CategoryService_label__3WIO7","location":"CategoryService_location__1ahzv"};